import {
  ADVERTISING_CONSENT_CHANGE_EVENT,
  ADVERTISING_CONSENT_STORAGE_KEY,
  type AdvertisingConsentChoice,
} from "@/lib/advertisingConsent";
import { setGoogleConsent } from "@/lib/setGoogleConsent";
import { Cookies } from "@garimpa/lib/cookies";
import { serializeCookie } from "@garimpa/lib/serializeCookie";

export function persistAdvertisingConsent(
  choice: AdvertisingConsentChoice,
  storage?: Pick<Storage, "setItem"> | null,
): void {
  try {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
      document.cookie = serializeCookie(Cookies.advertisingConsent, choice, {
        secure: window.location.protocol === "https:",
      });
    }
  } catch {
    // A blocked cookie must not prevent storage or the current consent choice.
  }

  try {
    const target = storage ?? (typeof window === "undefined" ? null : window.localStorage);
    target?.setItem(ADVERTISING_CONSENT_STORAGE_KEY, choice);
  } catch {
    // Storage failures must not block the visitor's current consent choice.
  }

  setGoogleConsent(choice);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(ADVERTISING_CONSENT_CHANGE_EVENT));
  }
}
